"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OUTER_RADIUS = exports.DEFAULT_INNER_RADIUS = void 0;
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const TEXT_OFFSET = 3;
exports.DEFAULT_INNER_RADIUS = 5;
exports.DEFAULT_OUTER_RADIUS = 10;
function Annotations(_ref) {
  let {
    data,
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {}
  } = _ref;
  const annotations = data.map((_ref2, i) => {
    let {
      x = 0,
      y = 0,
      title = '',
      position = 'above',
      color: annotationColor,
      showTitleOnChart = true,
      opacity = 1,
      fontSize = constants_1.DEFAULT_FONT_SIZE
    } = _ref2;
    const color = (0, colors_1.parseColor)(annotationColor, '#5E5E5E');
    const positionMultiplier = position === 'below' ? 1 : -1;
    const textPosition = y + (exports.DEFAULT_OUTER_RADIUS * 2 + TEXT_OFFSET) * positionMultiplier;
    const labelOpacity = showTitleOnChart ? 1 : 0;
    return {
      key: title || i,
      x,
      y,
      textPosition,
      title,
      position,
      color,
      labelOpacity,
      opacity,
      innerRadius: exports.DEFAULT_INNER_RADIUS,
      outerRadius: exports.DEFAULT_OUTER_RADIUS,
      fontSize
    };
  });
  return react_1.default.createElement("g", {
    className: "annotations"
  }, annotations.map((annotation, i) => {
    if (annotation) {
      const {
        x,
        y,
        position,
        textPosition,
        color,
        opacity,
        innerRadius,
        outerRadius,
        fontSize,
        labelOpacity
      } = annotation;
      return react_1.default.createElement("g", {
        key: annotation.key,
        opacity: opacity
      }, react_1.default.createElement("circle", {
        cx: x,
        cy: y,
        r: outerRadius,
        fill: color,
        fillOpacity: 0.3,
        stroke: color,
        strokeWidth: 1,
        onMouseOver: event => onMouseOver(event, i),
        onMouseOut: event => onMouseOut(event, i),
        onClick: event => onClick(event, i)
      }), react_1.default.createElement("circle", {
        cx: x,
        cy: y,
        r: innerRadius,
        fill: color,
        pointerEvents: "none"
      }), react_1.default.createElement("text", {
        textAnchor: "middle",
        dominantBaseline: position === 'below' ? 'text-top' : 'text-top',
        x: x,
        y: textPosition,
        fontSize: fontSize,
        dy: "0.35em",
        fill: "#212121",
        opacity: labelOpacity,
        pointerEvents: "none"
      }, annotation.title));
    }
    return null;
  }));
}
Annotations.propTypes = {
  /**
   * Annotation data
   */
  data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    title: prop_types_1.string.isRequired,
    x: prop_types_1.number.isRequired,
    y: prop_types_1.number.isRequired,
    showTitleOnChart: prop_types_1.bool,
    position: (0, prop_types_1.oneOf)(['above', 'below']),
    color: prop_types_1.string,
    fontSize: prop_types_1.number,
    opacity: prop_types_1.number,
    radius: prop_types_1.number
  })).isRequired,
  /**
   * function to activate on click
   * parameters: (event, index)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, index)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index)
   */
  onMouseOut: prop_types_1.func
};
exports.default = Annotations;